const send = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2.74014%202.25204L22.2361%2012L2.74014%2021.748L4.10515%2012.1929L4.8769%2012L4.10515%2011.8071L2.74014%202.25204ZM5.25987%205.74797L5.89486%2010.1929L13.1231%2012L5.89486%2013.8071L5.25987%2018.252L17.7639%2012L5.25987%205.74797Z'/%3e%3c/svg%3e";
export {
  send as default
};
//# sourceMappingURL=send.svg.es.js.map
